module.exports = __webpack_public_path__ + "media/configurations/ZOC_X-O-8f32d8fe.png";